module.exports = __webpack_public_path__ + "img/RepGuideLogo.0a820534.svg";